<template>
  <Drawer
    :id="drawerId"
    title="Certificate Details"
    padded
    hideBack
    :loading="loading"
  >
    <div>
      <v-sheet class="rounded border bg-light bordered border-light pa-4 mb-5 body-2">
        <div
          v-for="(item, index) in summary"
          :key="index"
          class="mb-1"
        >
          <span class="font-weight-bold mr-1">{{ item.text }}</span> {{ item.value }}
        </div>
      </v-sheet>

      <v-sheet
        v-if="certificate.userNote"
        class="rounded border bg-light bordered border-light pa-4 mb-5 body-2"
      >
        <div class="font-weight-bold mr-2">
          User Provided Note:
        </div>{{ certificate.userNote }}
      </v-sheet>

      <CertificateUploadButton
        viewOnly
        :certificateId="certificate.id"
        buttonText="Download Certificate"
      />

      <v-divider class="my-6" />

      <v-text-field
        v-model="edit_certificate.name"
        outlined
        label="Cerficiate Name"
        placeholder="Certificate Name"
        persistent-placeholder
        maxlength="100"
        hide-details="auto"
        class="white my-5"
      />

      <v-menu
        ref="menu"
        :close-on-content-click="false"
        :return-value.sync="edit_certificate.expirationDate"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="dateFormatted"
            label="Expiration Date"
            placeholder="Expiration Date"
            persistent-placeholder
            hide-details="auto"
            readonly
            outlined
            v-bind="attrs"
            v-on="on"
          />
        </template>
        <v-date-picker
          v-model="edit_certificate.expirationDate"
          no-title
          scrollable
          color="brand"
        >
          <v-btn
            text
            color="brand"
            @click="$refs.menu.save(null)"
          >
            Clear
          </v-btn>
          <v-spacer />
          <v-btn
            text
            color="brand"
            @click="() =>$refs.menu.save(edit_certificate.expirationDate)"
          >
            OK
          </v-btn>
        </v-date-picker>
      </v-menu>

      <v-select
        v-model="edit_certificate.statusId"
        outlined
        label="Status"
        placeholder="Status"
        persistent-placeholder
        :items="statuses"
        item-text="value"
        item-value="key"
        hide-details="auto"
        :rules="[$rules.required]"
        class="white my-5"
      />

      <v-textarea
        v-show="edit_certificate.statusId === rejectedStatusId"
        v-model="edit_certificate.rejectionNote"
        label="Rejection note (this will be emailed to the user)"
        persistent-placeholder
        outlined
        class="body-2 mt-5"
        maxlength="500"
        hide-details="auto"
      />

      <Portal :to="`drawerAppend-${drawerId}`">
        <v-row class="border border-t border-light pa-2 ma-0">
          <v-col cols="12">
            <v-btn
              :loading="saving"
              x-large
              block
              color="black"
              class="white--text"
              elevation="0"
              @click="save"
            >
              Save
            </v-btn>
          </v-col>
        </v-row>
      </Portal>
    </div>
  </Drawer>
</template>

<script>
import { DRAWERS, EXEMPTION_CERTIFICATE_STATUS } from '@/utils/constants';
import Drawer from '@/components/layout/Drawer';
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
import CertificateUploadButton from '../../../components/profile/nonprofit/CertificateUploadButton';
import { APP_EVENTS } from '../../../utils/constants';

export default {
  name: 'AdminCertificatesDrawer',

  components: {
    Drawer,
    CertificateUploadButton
  },

  data () {
    return {
      drawerId: DRAWERS.ADMIN_EXEMPTION_CERTIFICATES_DRAWER,
      loading: false,
      certificate: {},
      edit_certificate: {},
      saving: false,
      rejectedStatusId: EXEMPTION_CERTIFICATE_STATUS.REJECTED
    };
  },

  computed: {
    summary () {
      if (!this.certificate.id) return [];
      return [{
        text: 'Email:',
        value: this.certificate.email
      }, {
        text: 'Tax ID #:',
        value: this.$options.filters.ein(this.certificate.companyInfo.taxIdNumber)
      }, {
        text: 'Address:',
        value: this.certificate.companyInfo.address.simpleDisplay
      }];
    },

    statuses () {
      return this.$store.state.lookups.taxExemptCertificateStatuses;
    },

    dateFormatted () {
      return this.$options.filters.normalDate(this.edit_certificate.expirationDate);
    },

    ...mapGetters({
      initialData: 'drawers/data',
      drawerOpenedAt: 'drawers/lastOpenedAt'
    })
  },

  watch: {
    drawerOpenedAt () {
      if (this.drawerId === this.$store.getters['drawers/topDrawer']?.id) {
        var id = this.initialData(this.drawerId).certificateId;
        this.loading = true;
        this.$api.get(`taxExemptCertificates/detail?id=${id}`)
          .then((response) => {
            this.certificate = response.data;
            this.edit_certificate = cloneDeep(this.certificate);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  },

  methods: {
    async save () {
      this.saving = true;
      await this.$api.post('taxExemptCertificates/update', this.edit_certificate)
        .then((response) => {
          this.$eventBus.$emit(APP_EVENTS.TAX_EXEMPT_CERT_UPDATED, response.data);
          this.$store.commit('drawers/CLOSE_DRAWER', this.drawerId);
          this.$root.$snackbarSuccess('The tax exempt certificate was succcessfully saved.');
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>

  <style scoped>
  </style>
